import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'


/* ----------------------- FAQ FEEDBACK SURVEY STATE STORE ----------------------- */
/* 
use for storing if user has answered the feedback survey
*/

type SurveyState = {
  isAnswered: boolean 
}

type SurveyAction = {
  updateSurveyIsAnswered: (s: boolean) => void
}

export const useSurveyStore = create<SurveyState & SurveyAction>()(persist(set => ({
  isAnswered: false,
  updateSurveyIsAnswered: (state: boolean) => set(() => ({ isAnswered: state }))
}),
  {
    name: 'faq-survey-state',
    storage: createJSONStorage(() => sessionStorage)
}
))
